module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Text Input consists of a label and a text field.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;TextInput label       = &quot;What is your name?&quot;\n           placeholder = &quot;Max Mustermann&quot;/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/TextInput/README.md
// module id = 405
// module chunks = 0